var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cale"}},[_c('FullCalendar',{ref:"calendar",attrs:{"options":_vm.calendarOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }